import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthenticationCard } from "@/components/ui/authentication-card";
import { useAuth } from "@/contexts/AuthContext";

export function LoginPage() {
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();

	const { login } = useAuth();

	const handleSubmit = async (
		email: string,
		password: string,
		keepLoggedIn: boolean,
	) => {
		if (!email || !password) {
			setError("Please fill in all fields");
			return;
		}

		setIsLoading(true);
		setError("");

		try {
			await login(email, password);
			// Note: keepLoggedIn functionality could be implemented in the auth context
			console.log("Keep logged in:", keepLoggedIn);
			navigate("/dashboard");
		} catch (error) {
			console.error("Login error:", error);
			// Show the actual error message if available
			const errorMessage =
				error instanceof Error
					? error.message
					: (error as any)?.message || "Invalid email or password";
			setError(errorMessage);
		} finally {
			setIsLoading(false);
		}
	};

	const handleGitHubLogin = () => {
		console.log("GitHub OAuth clicked");
		// TODO: Implement GitHub OAuth integration
	};

	const handleForgotPassword = () => {
		console.log("Forgot password clicked");
		// TODO: Implement forgot password flow
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
			<AuthenticationCard
				onSubmit={handleSubmit}
				onGitHubLogin={handleGitHubLogin}
				onForgotPassword={handleForgotPassword}
				error={error}
				isLoading={isLoading}
			/>
		</div>
	);
}
